import React from 'react';

const buttonStyle = { minHeight: 44, padding: '0 12px', border: 0, background: 'transparent',
  color: 'inherit', font: 'inherit', fontSize: 12, cursor: 'pointer', touchAction: 'manipulation' };

export default function MobileGameControls({ onFullscreen, onExit, onExternal, external }) {
  return <footer aria-label="게임 실행 도구" style={{ display: 'flex', alignItems: 'center',
    minHeight: 44, paddingBottom: 'env(safe-area-inset-bottom, 0px)', color: '#fff',
    background: '#181818', borderTop: '1px solid #303030' }}>
    {!external && <button type="button" style={buttonStyle} onClick={onFullscreen}>전체화면</button>}
    <button type="button" style={buttonStyle} onClick={onExternal}>{external ? '새창 닫고 내부로 복귀' : '새창 열기'}</button>
    <button type="button" style={{ ...buttonStyle, marginLeft: 'auto', fontWeight: 600 }} onClick={onExit}>게임 종료 <span aria-hidden="true">×</span></button>
  </footer>;
}
